// src/mock-data.ts
import {
  UserRole,
  ServiceStatus,
  HardwareAccelType,
  FFmpegPreset,
  VideoProfile,
  ProcessStatus,
  LogLevel,
  ResolutionPreset
} from "@xtream/shared-types";
var DEFAULT_USER_ID = "550e8400-e29b-41d4-a716-446655440001";
var DEFAULT_USERNAME = "admin";
var mockUsers = [
  {
    id: "550e8400-e29b-41d4-a716-446655440001",
    username: "admin",
    email: "admin@xtream.local",
    role: UserRole.ADMIN,
    isActive: true,
    lastLoginAt: "2026-02-04T18:00:00Z",
    createdAt: "2026-01-01T00:00:00Z",
    updatedAt: "2026-02-04T18:00:00Z"
  },
  {
    id: "550e8400-e29b-41d4-a716-446655440002",
    username: "operator1",
    email: "operator1@xtream.local",
    role: UserRole.OPERATOR,
    isActive: true,
    lastLoginAt: "2026-02-04T15:30:00Z",
    createdAt: "2026-01-15T10:00:00Z",
    updatedAt: "2026-02-04T15:30:00Z"
  },
  {
    id: "550e8400-e29b-41d4-a716-446655440003",
    username: "viewer1",
    email: "viewer1@xtream.local",
    role: UserRole.VIEWER,
    isActive: true,
    lastLoginAt: "2026-02-03T09:00:00Z",
    createdAt: "2026-01-20T14:00:00Z",
    updatedAt: "2026-02-03T09:00:00Z"
  },
  {
    id: "550e8400-e29b-41d4-a716-446655440004",
    username: "operator2",
    email: "operator2@xtream.local",
    role: UserRole.OPERATOR,
    isActive: false,
    lastLoginAt: "2026-01-25T12:00:00Z",
    createdAt: "2026-01-10T08:00:00Z",
    updatedAt: "2026-02-01T10:00:00Z"
  }
];
var mockQualities = [
  {
    id: "quality-001",
    serviceId: "service-001",
    name: "1080p",
    resolution: ResolutionPreset.RES_1080P,
    width: 1920,
    height: 1080,
    videoBitrate: 6e3,
    audioBitrate: 192,
    preset: FFmpegPreset.VERYFAST,
    profile: VideoProfile.HIGH,
    level: "4.1",
    fps: 30,
    enabled: true,
    priority: 0,
    createdAt: "2026-01-15T10:00:00Z",
    updatedAt: "2026-01-15T10:00:00Z"
  },
  {
    id: "quality-002",
    serviceId: "service-001",
    name: "720p",
    resolution: ResolutionPreset.RES_720P,
    width: 1280,
    height: 720,
    videoBitrate: 3e3,
    audioBitrate: 128,
    preset: FFmpegPreset.VERYFAST,
    profile: VideoProfile.MAIN,
    level: "4.0",
    fps: 30,
    enabled: true,
    priority: 1,
    createdAt: "2026-01-15T10:00:00Z",
    updatedAt: "2026-01-15T10:00:00Z"
  },
  {
    id: "quality-003",
    serviceId: "service-001",
    name: "480p",
    resolution: ResolutionPreset.RES_480P,
    width: 854,
    height: 480,
    videoBitrate: 1500,
    audioBitrate: 96,
    preset: FFmpegPreset.VERYFAST,
    profile: VideoProfile.MAIN,
    level: "3.1",
    fps: 30,
    enabled: true,
    priority: 2,
    createdAt: "2026-01-15T10:00:00Z",
    updatedAt: "2026-01-15T10:00:00Z"
  },
  {
    id: "quality-004",
    serviceId: "service-001",
    name: "360p",
    resolution: ResolutionPreset.RES_360P,
    width: 640,
    height: 360,
    videoBitrate: 800,
    audioBitrate: 64,
    preset: FFmpegPreset.FAST,
    profile: VideoProfile.BASELINE,
    level: "3.0",
    fps: 30,
    enabled: false,
    priority: 3,
    createdAt: "2026-01-15T10:00:00Z",
    updatedAt: "2026-01-15T10:00:00Z"
  }
];
var mockOutputs = [
  {
    id: "output-001",
    serviceId: "service-001",
    name: "Wowza Primary",
    url: "rtmp://wowza-primary.xtream.local/live",
    streamKey: "stream123_1080p",
    username: "publisher",
    qualityId: "quality-001",
    enabled: true,
    priority: 0,
    lastConnectedAt: "2026-02-04T18:00:00Z",
    lastDisconnectedAt: null,
    connectionErrors: 0,
    createdAt: "2026-01-15T10:00:00Z",
    updatedAt: "2026-02-04T18:00:00Z"
  },
  {
    id: "output-002",
    serviceId: "service-001",
    name: "Wowza Backup",
    url: "rtmp://wowza-backup.xtream.local/live",
    streamKey: "stream123_backup",
    username: null,
    qualityId: null,
    enabled: true,
    priority: 1,
    lastConnectedAt: "2026-02-04T18:00:00Z",
    lastDisconnectedAt: null,
    connectionErrors: 0,
    createdAt: "2026-01-15T10:00:00Z",
    updatedAt: "2026-02-04T18:00:00Z"
  },
  {
    id: "output-003",
    serviceId: "service-002",
    name: "CDN Edge",
    url: "rtmp://cdn-edge.xtream.local/ingest",
    streamKey: "event_main",
    username: "cdn_user",
    qualityId: "quality-005",
    enabled: true,
    priority: 0,
    lastConnectedAt: null,
    lastDisconnectedAt: "2026-02-03T20:00:00Z",
    connectionErrors: 2,
    createdAt: "2026-01-20T14:00:00Z",
    updatedAt: "2026-02-03T20:00:00Z"
  }
];
var mockServices = [
  {
    id: "service-001",
    name: "Main Event Stream",
    description: "Primary streaming service for live events",
    inputUrl: "rtmp://source.xtream.local/live/main_feed",
    status: ServiceStatus.RUNNING,
    hardwareAccel: HardwareAccelType.NVENC,
    lowLatency: true,
    sourceMetadata: null,
    errorMessage: null,
    createdById: "550e8400-e29b-41d4-a716-446655440001",
    createdAt: "2026-01-15T10:00:00Z",
    updatedAt: "2026-02-04T18:00:00Z",
    lastStartedAt: "2026-02-04T08:00:00Z",
    lastStoppedAt: "2026-02-03T22:00:00Z",
    qualities: mockQualities.filter((q) => q.serviceId === "service-001"),
    outputs: mockOutputs.filter((o) => o.serviceId === "service-001"),
    createdBy: {
      id: "550e8400-e29b-41d4-a716-446655440001",
      username: "admin"
    }
  },
  {
    id: "service-002",
    name: "Backup Channel",
    description: "Secondary backup stream",
    inputUrl: "rtmp://source.xtream.local/live/backup_feed",
    status: ServiceStatus.STOPPED,
    hardwareAccel: HardwareAccelType.NONE,
    lowLatency: false,
    sourceMetadata: null,
    errorMessage: null,
    createdById: "550e8400-e29b-41d4-a716-446655440002",
    createdAt: "2026-01-20T14:00:00Z",
    updatedAt: "2026-02-03T20:00:00Z",
    lastStartedAt: "2026-02-03T10:00:00Z",
    lastStoppedAt: "2026-02-03T20:00:00Z",
    qualities: [
      {
        id: "quality-005",
        serviceId: "service-002",
        name: "720p",
        resolution: ResolutionPreset.RES_720P,
        width: 1280,
        height: 720,
        videoBitrate: 2500,
        audioBitrate: 128,
        preset: FFmpegPreset.FAST,
        profile: VideoProfile.MAIN,
        level: "4.0",
        fps: 30,
        enabled: true,
        priority: 0,
        createdAt: "2026-01-20T14:00:00Z",
        updatedAt: "2026-01-20T14:00:00Z"
      }
    ],
    outputs: mockOutputs.filter((o) => o.serviceId === "service-002"),
    createdBy: {
      id: "550e8400-e29b-41d4-a716-446655440002",
      username: "operator1"
    }
  },
  {
    id: "service-003",
    name: "Test Stream",
    description: "Testing and development stream",
    inputUrl: "rtmp://source.xtream.local/test/feed",
    status: ServiceStatus.ERROR,
    hardwareAccel: HardwareAccelType.NONE,
    lowLatency: true,
    sourceMetadata: null,
    errorMessage: "Input stream connection timeout after 30 seconds",
    createdById: "550e8400-e29b-41d4-a716-446655440001",
    createdAt: "2026-02-01T09:00:00Z",
    updatedAt: "2026-02-04T16:30:00Z",
    lastStartedAt: "2026-02-04T16:00:00Z",
    lastStoppedAt: "2026-02-04T16:30:00Z",
    qualities: [
      {
        id: "quality-006",
        serviceId: "service-003",
        name: "480p Test",
        resolution: ResolutionPreset.RES_480P,
        width: 854,
        height: 480,
        videoBitrate: 1e3,
        audioBitrate: 64,
        preset: FFmpegPreset.ULTRAFAST,
        profile: VideoProfile.BASELINE,
        level: "3.0",
        fps: 25,
        enabled: true,
        priority: 0,
        createdAt: "2026-02-01T09:00:00Z",
        updatedAt: "2026-02-01T09:00:00Z"
      }
    ],
    outputs: [
      {
        id: "output-004",
        serviceId: "service-003",
        name: "Test Output",
        url: "rtmp://test.xtream.local/test",
        streamKey: "test_key",
        username: null,
        qualityId: null,
        enabled: true,
        priority: 0,
        lastConnectedAt: "2026-02-04T16:00:00Z",
        lastDisconnectedAt: "2026-02-04T16:30:00Z",
        connectionErrors: 5,
        createdAt: "2026-02-01T09:00:00Z",
        updatedAt: "2026-02-04T16:30:00Z"
      }
    ],
    createdBy: {
      id: "550e8400-e29b-41d4-a716-446655440001",
      username: "admin"
    }
  }
];
var mockProgressData = {
  fps: 29.97,
  bitrate: 6250.5,
  frame: 54321,
  time: "00:30:12.45",
  speed: 1
};
var mockProcesses = [
  {
    id: "process-001",
    serviceId: "service-001",
    pid: 12345,
    status: ProcessStatus.RUNNING,
    startedAt: "2026-02-04T08:00:00Z",
    stoppedAt: null,
    currentFps: 29.97,
    currentBitrate: 6250.5,
    currentFrame: 54321,
    currentTime: "00:30:12.45",
    errorMessage: null,
    exitCode: null,
    createdAt: "2026-02-04T08:00:00Z",
    updatedAt: "2026-02-04T18:30:12Z"
  },
  {
    id: "process-002",
    serviceId: "service-003",
    pid: null,
    status: ProcessStatus.FAILED,
    startedAt: "2026-02-04T16:00:00Z",
    stoppedAt: "2026-02-04T16:30:00Z",
    currentFps: 0,
    currentBitrate: 0,
    currentFrame: 1500,
    currentTime: "00:00:50.00",
    errorMessage: "Input stream connection timeout after 30 seconds",
    exitCode: 1,
    createdAt: "2026-02-04T16:00:00Z",
    updatedAt: "2026-02-04T16:30:00Z"
  }
];
var mockProcessLogs = [
  {
    id: "log-001",
    processId: "process-001",
    level: LogLevel.INFO,
    message: "FFmpeg process started with PID 12345",
    timestamp: "2026-02-04T08:00:00Z"
  },
  {
    id: "log-002",
    processId: "process-001",
    level: LogLevel.INFO,
    message: "Input stream connected: rtmp://source.xtream.local/live/main_feed",
    timestamp: "2026-02-04T08:00:01Z"
  },
  {
    id: "log-003",
    processId: "process-001",
    level: LogLevel.INFO,
    message: "Output connected: Wowza Primary",
    timestamp: "2026-02-04T08:00:02Z"
  },
  {
    id: "log-004",
    processId: "process-001",
    level: LogLevel.DEBUG,
    message: "Frame rate stabilized at 29.97 fps",
    timestamp: "2026-02-04T08:00:05Z"
  },
  {
    id: "log-005",
    processId: "process-002",
    level: LogLevel.INFO,
    message: "FFmpeg process started",
    timestamp: "2026-02-04T16:00:00Z"
  },
  {
    id: "log-006",
    processId: "process-002",
    level: LogLevel.WARN,
    message: "Waiting for input stream...",
    timestamp: "2026-02-04T16:00:05Z"
  },
  {
    id: "log-007",
    processId: "process-002",
    level: LogLevel.ERROR,
    message: "Input stream connection timeout after 30 seconds",
    timestamp: "2026-02-04T16:00:35Z"
  }
];
function generateUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === "x" ? r : r & 3 | 8;
    return v.toString(16);
  });
}
function generateMockUser(overrides = {}) {
  const now = (/* @__PURE__ */ new Date()).toISOString();
  return {
    id: generateUUID(),
    username: `user_${Math.random().toString(36).substring(7)}`,
    email: `user_${Date.now()}@xtream.local`,
    role: UserRole.OPERATOR,
    isActive: true,
    lastLoginAt: now,
    createdAt: now,
    updatedAt: now,
    ...overrides
  };
}
function generateMockQuality(serviceId, overrides = {}) {
  const now = (/* @__PURE__ */ new Date()).toISOString();
  return {
    id: generateUUID(),
    serviceId,
    name: "720p",
    resolution: ResolutionPreset.RES_720P,
    width: 1280,
    height: 720,
    videoBitrate: 2500,
    audioBitrate: 128,
    preset: FFmpegPreset.VERYFAST,
    profile: VideoProfile.MAIN,
    level: "4.0",
    fps: 30,
    enabled: true,
    priority: 0,
    createdAt: now,
    updatedAt: now,
    ...overrides
  };
}
function generateMockOutput(serviceId, overrides = {}) {
  const now = (/* @__PURE__ */ new Date()).toISOString();
  return {
    id: generateUUID(),
    serviceId,
    name: "Default Output",
    url: "rtmp://output.xtream.local/live",
    streamKey: `key_${Date.now()}`,
    username: null,
    qualityId: null,
    enabled: true,
    priority: 0,
    lastConnectedAt: null,
    lastDisconnectedAt: null,
    connectionErrors: 0,
    createdAt: now,
    updatedAt: now,
    ...overrides
  };
}
function generateMockService(overrides = {}) {
  const now = (/* @__PURE__ */ new Date()).toISOString();
  const serviceId = generateUUID();
  return {
    id: serviceId,
    name: `Service ${Date.now()}`,
    description: "Auto-generated test service",
    inputUrl: "rtmp://source.xtream.local/live/test",
    status: ServiceStatus.STOPPED,
    hardwareAccel: HardwareAccelType.NONE,
    lowLatency: true,
    sourceMetadata: null,
    errorMessage: null,
    createdById: DEFAULT_USER_ID,
    createdAt: now,
    updatedAt: now,
    lastStartedAt: null,
    lastStoppedAt: null,
    qualities: [generateMockQuality(serviceId)],
    outputs: [generateMockOutput(serviceId)],
    createdBy: {
      id: DEFAULT_USER_ID,
      username: DEFAULT_USERNAME
    },
    ...overrides
  };
}
function generateMockProgress(baseProgress = mockProgressData) {
  return {
    fps: baseProgress.fps + (Math.random() - 0.5) * 2,
    bitrate: baseProgress.bitrate + (Math.random() - 0.5) * 500,
    frame: baseProgress.frame + Math.floor(Math.random() * 30),
    time: baseProgress.time,
    speed: Math.max(0.8, Math.min(1.2, baseProgress.speed + (Math.random() - 0.5) * 0.1))
  };
}

// src/index.ts
function formatBitrate(kbps) {
  if (kbps >= 1e3) {
    return `${(kbps / 1e3).toFixed(1)} Mbps`;
  }
  return `${kbps.toFixed(0)} kbps`;
}
function formatResolution(width, height) {
  return `${width}x${height}`;
}
function formatDuration(time) {
  const parts = time.split(":");
  if (parts.length !== 3) return time;
  const hours = parts[0] ?? "0";
  const minutes = parts[1] ?? "0";
  const seconds = parts[2] ?? "0";
  const h = parseInt(hours, 10);
  const m = parseInt(minutes, 10);
  const s = parseFloat(seconds);
  if (h > 0) {
    return `${h}h ${m}m ${Math.floor(s)}s`;
  }
  if (m > 0) {
    return `${m}m ${Math.floor(s)}s`;
  }
  return `${s.toFixed(1)}s`;
}
function formatBytes(bytes) {
  const units = ["B", "KB", "MB", "GB", "TB"];
  let unitIndex = 0;
  let size = bytes;
  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }
  return `${size.toFixed(1)} ${units[unitIndex]}`;
}
function truncate(str, maxLength) {
  if (str.length <= maxLength) return str;
  return `${str.substring(0, maxLength - 3)}...`;
}
function deepClone(obj) {
  return structuredClone(obj);
}
function debounce(fn, delay) {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn(...args), delay);
  };
}
function throttle(fn, limit) {
  let inThrottle = false;
  return (...args) => {
    if (!inThrottle) {
      fn(...args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
}
function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
function isValidUUID(str) {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(str);
}
function isValidRtmpUrl(url) {
  try {
    const parsed = new URL(url);
    return parsed.protocol === "rtmp:" || parsed.protocol === "rtmps:";
  } catch {
    return false;
  }
}
export {
  debounce,
  deepClone,
  formatBitrate,
  formatBytes,
  formatDuration,
  formatResolution,
  generateMockOutput,
  generateMockProgress,
  generateMockQuality,
  generateMockService,
  generateMockUser,
  generateUUID,
  isValidRtmpUrl,
  isValidUUID,
  mockOutputs,
  mockProcessLogs,
  mockProcesses,
  mockProgressData,
  mockQualities,
  mockServices,
  mockUsers,
  sleep,
  throttle,
  truncate
};
